"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dealCardHeader = _interopRequireDefault(require("./dealCardHeader"));
var _dealCardbody = _interopRequireDefault(require("./dealCardbody"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DealCard = function DealCard(_ref) {
  var cardStyle = _ref.cardStyle,
    title = _ref.title,
    imageUrl = _ref.imageUrl,
    serviceProvider = _ref.serviceProvider,
    lazyLoadImage = _ref.lazyLoadImage;
  return /*#__PURE__*/React.createElement(_dealCardHeader["default"], {
    cardStyle: cardStyle,
    title: title,
    imageUrl: imageUrl,
    lazyLoadImage: lazyLoadImage
  }, /*#__PURE__*/React.createElement(_dealCardbody["default"], {
    spName: serviceProvider.name,
    reviewCount: serviceProvider.reviewCount,
    grade: serviceProvider.grade,
    cardStyle: cardStyle
  }));
};
DealCard.defaultProps = {
  imageUrl: undefined,
  lazyLoadImage: false
};
DealCard.propTypes = {
  title: _propTypes["default"].string.isRequired,
  imageUrl: _propTypes["default"].string,
  cardStyle: _propTypes["default"].string.isRequired,
  serviceProvider: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    grade: _propTypes["default"].string,
    reviewCount: _propTypes["default"].number
  }).isRequired,
  lazyLoadImage: _propTypes["default"].bool
};
var _default = exports["default"] = DealCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/offers/dealCard.js
// module id = 6375
// module chunks = 25